import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

import { ProfileWork } from "core/http/service/operationProcess/resTypes";

interface InitialState {
  status: ReduxStateType;
  data: ProfileWork[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: [],
};

const getProfileWorkSlice = createSlice({
  name: "getProfileWork",
  initialState,
  reducers: {
    getProfileWorkStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getProfileWorkSuccess: (state, action: PayloadAction<ProfileWork[]>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getProfileWorkFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetProfileWork: () => {
      return { ...initialState };
    },
  },
});

export const {
  getProfileWorkStart,
  getProfileWorkSuccess,
  getProfileWorkFailed,
  resetProfileWork,
} = getProfileWorkSlice.actions;

export default getProfileWorkSlice.reducer;
